import State from 'store/State';
import { selectPortfolioSummaryWidgetState } from 'widgets/portfolioSummary/store/instances/selectors';
import { useSelector } from 'react-redux';
import {
    initialPortfolioSummaryConfiguration,
    PortfolioSummaryConfigurationState,
} from 'widgets/portfolioSummary/store/instances/configuration/PortfolioSummaryConfigurationState';
import { selectComponentKeysByType } from 'layout/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import uniq from 'lodash/uniq';
import { useWidgetContext } from 'widgets/WidgetContext';

export const selectPortfolioSummaryConfiguration: (
    state: State,
    widgetKey: string
) => PortfolioSummaryConfigurationState = (state, widgetKey) => {
    const portfolioSummaryState = selectPortfolioSummaryWidgetState(
        state,
        widgetKey
    );
    return portfolioSummaryState && portfolioSummaryState.config
        ? portfolioSummaryState.config
        : initialPortfolioSummaryConfiguration;
};

export const selectAggregationField = (state: State, widgetKey: string) =>
    selectPortfolioSummaryConfiguration(state, widgetKey).aggregationField;

export const usePortfolioSummaryConfigurationSelector = () => {
    const { widgetKey } = useWidgetContext();
    return useSelector((state: State) =>
        selectPortfolioSummaryConfiguration(state, widgetKey)
    );
};

export const selectAllWidgetsAggregationFields = (state: State) =>
    uniq(
        selectComponentKeysByType(state, WidgetType.PORTFOLIO_SUMMARY).map(
            (wk) => selectAggregationField(state, wk)
        )
    );
